import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, catchError, map } from 'rxjs';

import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';
import { timesheetLockingRequestModel, timesheetLockingResponseModel } from './timesheet-lock';

@Injectable({
  providedIn: 'root'
})
export class TimesheetLockService {

  constructor(
    private httpClient: HttpClient
  ) { }

  timesheet_lock_get(staff_id: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.timesheet_locking + `?staff_ids=${staff_id}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  timesheet_lock_post(timesheetLockingRequest: timesheetLockingRequestModel): Observable<timesheetLockingResponseModel> {
    return this.httpClient.post<timesheetLockingResponseModel>(apiEndpoints.timesheet_locking, timesheetLockingRequest).pipe(
      map((response: timesheetLockingResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  timesheet_Unlock(timesheetLockingRequest: timesheetLockingRequestModel): Observable<timesheetLockingResponseModel>{
    return this.httpClient.patch<timesheetLockingResponseModel>(apiEndpoints.timesheet_locking_staff_delete, timesheetLockingRequest).pipe(
      map((response: timesheetLockingResponseModel) => 
      response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later')
      })
    )
  }
}
